<template>
    <div id="CheckoutPayment" class="checkout-step" :class="{active: getCheckoutStep === 4}">
        <p class="heading">Payment options</p>
        <hr>
        <div class="payment-option">
            <input id="pxpay-option" Name="PaymentMethod" type="radio" value="pxpay" v-model="paymentMethod">
            <label for="pxpay-option" :class="{active: paymentMethod === 'pxpay'}">New Credit Card</label>
            <i class="fad fa-credit-card"></i>
        </div>

        <div class="payment-option" v-if="getMember.SavedCard && getMember.SavedCard.ID">
            <input id="pxpost-option" Name="PaymentMethod" type="radio" value="pxpost" v-model="paymentMethod">
            <label for="pxpost-option" :class="{active: paymentMethod === 'pxpost'}">My Card {{ getMember.SavedCard.CardNumber }}</label>
            <i class="fab fa-cc-visa"></i>
        </div>

        <div class="environmental">
            <div class="title">
                <img :src="getSettings.EnvironmentalLogo.URL" v-if="getSettings.EnvironmentalLogo">
                <a :href="getSettings.EnvironmentalPage.Link" v-if="getSettings.EnvironmentalPage">More Info</a>
            </div>
            <hr>
            <div class="blurb" v-html="getSettings.EnvironmentalBlurb"></div>
            <p class="heading">Donate</p>
            <div class="donate">
                <div>
                    <input id="default-Amount" type="radio" value="default" v-model="donation">
                    <label for="default-Amount" :class="{active: donation === 'default'}">$2</label>
                </div>
                <div>
                    <input id="custom-Amount" type="radio" value="custom" v-model="donation">
                    <input type="number" min="0" placeholder="Enter custom amount" v-model="donationAmount" :disabled="donation !== 'custom'">
                </div>
                <button class="btn btn-light-small" @click="toggleDonation()">Apply</button>
            </div>
        </div>

        <template v-if="processing">
            <button class="btn btn-checkout shadow-light disabled">Processing..</button>
        </template>
        <template v-else>
            <button class="btn btn-checkout shadow-light" @click="handlePayment()">Pay Now</button>
        </template>
        <p class="btn-icon match-height" @click.stop="setCheckoutStep(1)"><i class="fal fa-long-arrow-right"></i>Back to Cart</p>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

const {required, minLength, email, sameAs} = require('vuelidate/lib/validators');

export default {
    name: "CheckoutPayment",
    data() {
        return {
            paymentMethod: 'pxpay',
            donation: 'default',
            donationAmount: null,
            processing: false
        };
    },
    computed: {
        ...mapGetters(['getCheckoutStep', 'getItems', 'getOrder', 'getMember', 'getSettings'])
    },
    methods: {
        ...mapActions(['setCheckoutStep', 'payOrder', 'applyDonation']),
        handlePayment() {
            this.showErrors = true;
            let data = new FormData();
            data.append('PaymentMethod', this.paymentMethod);
            this.processing = true;

            if (this.$gtm.enabled()) {
                let itemsList = []

                this.getItems.forEach((item) => {
                    let product = item.Product;

                    itemsList.push({
                        'item_id': product.ID,
                        'item_name': product.Title,
                        'price': product.LocalisedPrice,
                        'item_category': product.ProductType,
                        'quantity': item.Quantity
                    })
                })

                window.dataLayer?.push({ecommerce: null});
                window.dataLayer?.push({
                    'event': 'add_payment_info',
                    'payment_type': this.paymentMethod,
                    'ecommerce': {
                        'items': itemsList
                    }
                });
            }

            this.payOrder(data);
        },
        toggleDonation() {
            let amount = 2,
                data = new FormData();
            if (this.donation !== 'default') {
                amount = this.donationAmount;
            }
            data.append('Donation', amount);
            if (amount > 0) {
                this.applyDonation(data);
            }
        }
    }
}
</script>
